import type CopilotPrioritizeSettings from '../types/CopilotPrioritizeSettings';
import defaultCopilotPrioritizeSettings from '../types/defaultCopilotPrioritizeSettings';
import getStore from '../store/store';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import isCopilotPrioritizeSettingsInitialized from './isCopilotPrioritizeSettingsInitialized';

export default function getCopilotPrioritizeSettings(
    mailboxInfo: MailboxInfo
): CopilotPrioritizeSettings {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const store = getStore().copilotPrioritizeSettingsStoreMap.get(accountKey);

    if (!isCopilotPrioritizeSettingsInitialized(mailboxInfo) || !store) {
        return defaultCopilotPrioritizeSettings;
    }

    return store.settings;
}
